"use client";

import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";

export default function GlobalError({
	error,
	reset,
}: {
	error: Error & { digest?: string };
	reset: () => void;
}) {
	useEffect(() => {
		Sentry.captureException(error);
	}, [error]);

	return (
		<html lang="en">
			<body>
				<div
					style={{
						minHeight: "100vh",
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						justifyContent: "center",
						textAlign: "center",
						padding: "24px",
						fontFamily:
							'-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
						backgroundColor: "var(--muted)",
					}}
				>
					<div
						style={{
							fontSize: "64px",
							marginBottom: "16px",
						}}
					>
						&#9888;
					</div>
					<h1
						style={{
							fontSize: "24px",
							fontWeight: 700,
							color: "#333",
							margin: "0 0 8px",
						}}
					>
						Something went wrong
					</h1>
					<p
						style={{
							fontSize: "16px",
							color: "#666",
							margin: "0 0 32px",
							maxWidth: "400px",
						}}
					>
						{error.message || "An unexpected error occurred. Please try again."}
					</p>
					<button
						type="button"
						onClick={reset}
						style={{
							padding: "10px 32px",
							fontSize: "16px",
							fontWeight: 600,
							color: "#fff",
							backgroundColor: "var(--brand-primary-emphasis)",
							border: "none",
							borderRadius: "8px",
							cursor: "pointer",
						}}
					>
						Try again
					</button>
				</div>
			</body>
		</html>
	);
}
